import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import ProfileCover from '../../common/profile-cover';
import SubscriptionPrice from '../../common/subscription-price';
import EditProfileForm from '../../common/edit-profile-form';
import { useToasts } from 'react-toast-notifications';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import PRainbowToast from '../../common/PRainbowToast';
import AlertConfirmModal from '../../common/AlertConfirmModal';
import useIsAuth from '../../utils/useIsAuth';
import { ROLES, supportLink } from '../../utils/constants';
import './edit-profile.css';
import PResendEmail from '../../common/PResendEmail';
import PAlert from '../../common/PAlert';
import MetaTags from 'react-meta-tags';
import useRedirectIfNoData from '../../utils/useRedirectIfNoData';
import { connect, useDispatch } from 'react-redux';
import { setUser } from '../../../redux/actions';
import {
    GoogleReCaptchaProvider
} from 'react-google-recaptcha-v3';
import { RECAPTCHA_SITE_KEY } from '../../utils/constants';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { useMediaQuery } from '@mui/material';
import DefaultPUWidget from '../../Widgets/PU/Default';
import DefaultWidget from '../../Widgets/SU/Default';
import PageHeader from '../../common/PageHeader';

const EditProfile = ({ user }) => {
    useRedirectIfNoData('/login');
    const isMobile = useMediaQuery('(max-width: 899px)');

    const dispatch = useDispatch();

    const [showToast, setShowToast] = useState(false);
    const [showToast2, setShowToast2] = useState(false);
    const [show, setShow] = useState(false);
    const [hasConfirm, setHasConfirm] = useState(false);
    const [alertText, setAlertText] = useState('');
    const [isBusy, setIsBusy] = useState(false);

    const [showAlert, setShowAlert] = useState(false);
    const [alertTitle, setAlertTitle] = useState(false);
    const [alertBody, setAlertBody] = useState('');

    const getUserInformation = () => {
        dispatch(setUser());
    };

    useEffect(() => {
        let isMounted = true;

        window.scrollTo(0, 0);
        getUserInformation();
        document.body.style.overflowX = "hidden";

        return () => {
            isMounted = false;
            document.body.style.overflowX = "auto";
        };
    }, []);

    return (<div className="container edit-profile-main-container pt-4">
        <MetaTags>
            <title>Edit Profile &#8211; Best way to make money as an influencer for your exclusive content</title>
            <meta name="description" content="Privaposts is a social media platform that lets influencers make money from their followers by keeping exclusive content hidden until a monthly subscription price has been paid." />
        </MetaTags>


        <Grid2
            container
            spacing={!isMobile ? 2 : 0}
        >
            <Grid2 md={8}>
                {Object.keys(user).length ? (!isBusy && !user.email_verified_at && <PResendEmail />) : null}
                <div className="edit-profile-settings text-center">
                    <PageHeader title='My Profile Settings' />
                    <Link to="/settings" className="btn theme-btn theme-btn-bordered mt-2">Advanced Settings</Link>
                </div>
                <div className="your-profile-link text-center py-4">
                    <h5 className="text-uppercase mb-0"><b>Your Profile Link</b></h5>
                    {user && <p style={{ marginBottom: '2px' }}>
                        {process.env.MIX_APP_URL}/{user.login}
                    </p>}
                    {user && <PRainbowToast
                        show={showToast}
                        setShow={setShowToast}
                        message={`Copied Link to ${process.env.MIX_APP_URL}/${user.login} profile!`}
                        customStyle={{ top: 75, left: '40%' }}
                    />}
                    {
                        user && <CopyToClipboard
                            text={`${process.env.MIX_APP_URL}/${user.login}`}
                            onCopy={() => setShowToast(true)}
                        >
                            <a className="btn theme-btn theme-btn-bordered">Copy Link</a>
                        </CopyToClipboard>
                    }
                </div>
                {user && <div className="your-referral-link text-center pb-4">
                    <h5 className="text-uppercase mb-0"><b>Your Referral Link</b></h5>
                    <p style={{ marginBottom: '2px' }}>
                        {process.env.MIX_APP_URL}?ref={user.referral_id}
                    </p>
                    <PRainbowToast
                        show={showToast2}
                        setShow={setShowToast2}
                        message={`Copied Referral Link ${process.env.MIX_APP_URL}?ref=${user.referral_id}`}
                        customStyle={{ top: 75, left: '40%' }}
                    />
                    <CopyToClipboard
                        text={`${process.env.MIX_APP_URL}?ref=${user.referral_id}`}
                        onCopy={() => setShowToast2(true)}
                    >
                        <a className="btn theme-btn theme-btn-bordered">Copy Link</a>
                    </CopyToClipboard>
                </div>}

                <div className="payout-pref-container my-4">
                    {user && <ProfileCover user={user} showHeader={false} getUserInformation={getUserInformation} />}
                </div>

                <div className="payout-pref-container mb-4">
                    {user && <SubscriptionPrice showHeader={false} getUserInformation={getUserInformation} />}
                </div>

                <div id="grecaptcha-provider" className="payout-pref-container mb-2 pb-4">
                    {user &&
                        <GoogleReCaptchaProvider
                            language="en"
                            useRecaptchaNet="true"
                            reCaptchaKey={RECAPTCHA_SITE_KEY}
                            scriptProps={{
                                defer: true, // optional, default to false
                                appendTo: 'body', // optional, default to "head", can be "head" or "body",
                            }}
                        >
                            <EditProfileForm user={user} showHeader={false} getUserInformation={getUserInformation} />
                        </GoogleReCaptchaProvider>
                    }
                </div>
            </Grid2>
            {
                !isMobile
                    ? <Grid2 className='pu-homepage__right' md={4}>
                        {
                            user && user.role == ROLES.PU ? <DefaultPUWidget /> : null
                        }
                        {
                            user && user.role == ROLES.SU ? <DefaultWidget /> : null
                        }
                    </Grid2>
                    : null
            }
        </Grid2>

        <PAlert show={showAlert} setShow={setShowAlert} title={alertTitle} body={alertBody} />
    </div>
    );
};

const mapStateToProps = state => {
    return {
        user: state.user.user
    };
};

export default connect(mapStateToProps)(EditProfile);
